import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileCatOpen, setMobileCatOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 80);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link
            to="/"
            className={`flex items-center gap-2 transition-colors ${
              scrolled
                ? "text-foreground-950 hover:text-primary-600"
                : "text-white hover:text-white/80"
            }`}
          >
            <span className="text-xl md:text-2xl font-heading font-bold tracking-tight">
              kakobuy<span className={scrolled ? "text-accent-500" : "text-accent-400"}>gay</span>
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/"
              className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all ${
                scrolled
                  ? "text-foreground-700 hover:bg-background-100"
                  : "text-white/90 hover:text-white hover:bg-white/10"
              }`}
            >
              <i className="ri-home-4-line mr-1.5"></i>
              Strona Główna
            </Link>

            <Link
              to="/artykul/jak-korzystac-z-kakobuy-spreadsheet"
              className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all ${
                scrolled
                  ? "text-foreground-700 hover:bg-background-100"
                  : "text-white/90 hover:text-white hover:bg-white/10"
              }`}
            >
              <i className="ri-book-open-line mr-1.5"></i>
              Poradnik Zakupów
            </Link>

            <div className="relative group">
              <button className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all ${
                scrolled
                  ? "bg-white border border-background-300/60 text-foreground-700 hover:bg-background-50"
                  : "bg-white/20 backdrop-blur-sm border border-white/30 text-white hover:bg-white/30"
              }`}>
                <i className="ri-grid-line"></i>
                <span>Kategorie</span>
                <i className="ri-arrow-down-s-line text-xs"></i>
              </button>
              <div className="absolute top-full right-0 mt-2 w-56 bg-white rounded-xl shadow-lg border border-background-200/70 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 max-h-80 overflow-y-auto">
                {categories.map((cat) => (
                  <a
                    key={cat.id}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-700 hover:bg-accent-50 hover:text-accent-700 transition-colors first:rounded-t-xl last:rounded-b-xl whitespace-nowrap"
                  >
                    <span className="w-5 h-5 flex items-center justify-center">
                      <i className={`${cat.icon} text-xs`}></i>
                    </span>
                    {cat.namePl}
                  </a>
                ))}
              </div>
            </div>

            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className={`px-5 py-2 rounded-full text-sm font-semibold whitespace-nowrap transition-all ${
                scrolled
                  ? "bg-primary-500 text-white hover:bg-primary-600"
                  : "bg-white text-primary-700 hover:bg-accent-100"
              }`}
            >
              Kakobuy Spreadsheet
            </a>
          </div>

          <button
            type="button"
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors ${
              scrolled
                ? "bg-background-100 text-foreground-800"
                : "bg-white/20 backdrop-blur-sm text-white"
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            {mobileOpen ? <i className="ri-close-line text-xl"></i> : <i className="ri-menu-line text-xl"></i>}
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden pb-6 bg-background-50 rounded-b-2xl shadow-lg mx-0 px-4 pt-2">
            <div className="space-y-1 mb-4">
              <Link
                to="/"
                className="flex items-center gap-3 px-4 py-3 text-sm font-medium text-foreground-700 hover:bg-accent-50 rounded-xl transition-colors"
                onClick={() => setMobileOpen(false)}
              >
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-50 text-accent-600">
                  <i className="ri-home-4-line"></i>
                </span>
                Strona Główna
              </Link>

              <Link
                to="/artykul/jak-korzystac-z-kakobuy-spreadsheet"
                className="flex items-center gap-3 px-4 py-3 text-sm font-medium text-foreground-700 hover:bg-accent-50 rounded-xl transition-colors"
                onClick={() => setMobileOpen(false)}
              >
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-50 text-accent-600">
                  <i className="ri-book-open-line"></i>
                </span>
                Poradnik Zakupów
              </Link>
            </div>

            <button
              onClick={() => setMobileCatOpen(!mobileCatOpen)}
              className="flex items-center justify-between w-full px-4 py-3 text-sm font-semibold text-foreground-800 bg-background-100 rounded-xl"
            >
              <span className="flex items-center gap-2">
                <i className="ri-grid-line"></i>
                Kategorie Produktów
              </span>
              <i className={`${mobileCatOpen ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} transition-transform`}></i>
            </button>

            {mobileCatOpen && (
              <div className="mt-2 grid grid-cols-2 gap-2 max-h-96 overflow-y-auto">
                {categories.map((cat) => (
                  <a
                    key={cat.id}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="flex items-center gap-2 px-3 py-2.5 text-xs text-foreground-700 hover:bg-accent-50 hover:text-accent-700 rounded-lg transition-colors whitespace-nowrap"
                    onClick={() => setMobileOpen(false)}
                  >
                    <span className="w-6 h-6 flex items-center justify-center rounded-md bg-accent-50/50 text-accent-600 flex-shrink-0">
                      <i className={`${cat.icon} text-xs`}></i>
                    </span>
                    {cat.namePl}
                  </a>
                ))}
              </div>
            )}

            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="flex items-center justify-center mt-4 px-5 py-3 rounded-full bg-primary-500 text-white text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              Kakobuy Spreadsheet
              <i className="ri-arrow-right-up-line ml-2"></i>
            </a>
          </div>
        )}
      </div>
    </nav>
  );
}